import { useState, useEffect } from "react";
import { Switch } from "@headlessui/react";
import { useSelector, useDispatch } from "react-redux";
import Loading from "./Loading";
import {
  insert,
  reset,
  showWarning01,
  hideWarning01,
  showError01,
  hideError01,
  showFailed,
  hideFailed,
  showLoading,
  hideLoading,
} from "./inmate_list/inmatesSlice";
import { env } from "../environment";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function SearchFormBasic() {
  // SEARCH FORM VARIBLES
  const [SCDCID, setSCDCID] = useState("");
  const [SID, setSID] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phonetic, setPhonetic] = useState(false);
  const [inmates, setInmates] = useState([]);
  /////////////////////////////////////////
  const [photo, setPhoto] = useState("");
  const loading = useSelector((state) => state.inmates.loading);
  const dispatch = useDispatch();
  useEffect(() => {
    if (inmates.length != 0) {
      dispatch(insert(inmates));
    }
  }, [inmates]);
  function handleScroll() {
    document.querySelector('[id="top-of-list"]').scrollIntoView();
  }
  const handleSubmit = (e) => {
    //console.log(SCDCID, SID, firstName, lastName, phonetic);

    e.preventDefault();

    dispatch(hideError01());
    if (SCDCID == "" && SID == "" && firstName == "" && lastName == "") {
      dispatch(reset());
      dispatch(hideWarning01());
      dispatch(hideFailed());
      dispatch(showError01());
      handleScroll();
      return;
    }

    if (
      (/^\d+$/.test(SCDCID) == false && SCDCID.length != 0) ||
      (SCDCID.length < 4 && SCDCID.length != 0)
    ) {
      dispatch(reset());
      dispatch(hideWarning01());
      dispatch(showFailed());
      dispatch(hideError01());
      handleScroll();

      return;
    }
    if (
      /^\d+$/.test(SID) == false &&
      SID.length != 0 &&
      (SID.at(0) != "S" || SID.at(1) != "C")
    ) {
      dispatch(reset());
      dispatch(hideWarning01());
      dispatch(showFailed());
      dispatch(hideError01());
      handleScroll();

      return;
    }
    dispatch(showLoading());
    // fetch(
    //   "http://localhost:8080/scdc-public/inmatePicture.do?youth=+&id=" + SCDCID
    // )
    //   .then(async (response) => {
    //     const reader = await response.body.getReader();
    //     return new ReadableStream({
    //       start(controller) {
    //         return pump();
    //         function pump() {
    //           return reader.read().then(({ done, value }) => {
    //             // When no more data needs to be consumed, close the stream
    //             if (done) {
    //               controller.close();
    //               return;
    //             }
    //             // Enqueue the next data chunk into our target stream
    //             controller.enqueue(value);
    //             return pump();
    //           });
    //         }
    //       },
    //     });
    //   })
    //   .then((stream) => new Response(stream))
    //   .then((response) => response.blob())
    //   .then((blob) => URL.createObjectURL(blob))
    //   .then(async (url) => {
    //     await setPhoto(url);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // console.log(photo);

    let fetchString =
      env +
      "inmateSearch.do?lastName=" +
      lastName +
      "&firstName=" +
      firstName +
      "&scdcId=" +
      SCDCID +
      "&sid=" +
      SID +
      "&phoneticMatch=" +
      (phonetic === false ? "" : true);

    fetch(fetchString, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.length == 250) {
          dispatch(showWarning01());
        } else {
          dispatch(hideWarning01());
        }
        if (res.length == 0) {
          dispatch(showFailed());
        } else {
          dispatch(hideFailed());
        }
        dispatch(hideLoading());
        handleScroll();
        dispatch(insert(res));
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <form
      className=" z-0 md:w-2/6 md:text-left w-10/12 p-2 text-center m-auto"
      onSubmit={handleSubmit}
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          handleSubmit(e);
        }
      }}
    >
      <label className="block text-sm font-medium text-gray-700"></label>
      <div className="mt-1 relative rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          {/* <span className="text-gray-500 sm:text-sm"></span> */}
        </div>

        <input
          type="text"
          name="SCDC ID"
          id="SCDCID"
          className="focus:ring-2 focus:border-blue-200 focus:outline-none block w-full  pl-3 pt-2 pb-2 mr-28 mb-2  border border-gray-300 rounded-md"
          placeholder="SCDC ID"
          value={SCDCID}
          onChange={(e) => setSCDCID(e.target.value)}
        ></input>
        <input
          type="text"
          name="SID"
          id="SID"
          className="focus:ring-2 focus:border-blue-200 focus:outline-none block w-full pl-3 pt-2 pb-2 mr-28 mb-2  border border-gray-300 rounded-md"
          placeholder="SID"
          value={SID}
          onChange={(e) => setSID(e.target.value)}
        ></input>
        <input
          type="text"
          name="firstName"
          id="firstName"
          className="focus:ring-2 focus:border-blue-200 focus:outline-none block w-full pl-3 pt-2 pb-2 mr-28 mb-2  border border-gray-300 rounded-md"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        ></input>
        <input
          type="text"
          name="lastName"
          id="lastName"
          className="focus:ring-2 focus:border-blue-200 focus:outline-none block w-full  pl-3 pt-2 pb-2 mr-28 mb-2  border border-gray-300 rounded-md"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        ></input>
        <div className="pb-2 inline-flex">
          {" "}
          <div className="pr-10">Phonetic Match</div>
          <Switch
            checked={phonetic}
            onChange={setPhonetic}
            className="flex-shrink-0 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-light"
          >
            <span className="sr-only"></span>
            <span
              aria-hidden="true"
              className="pointer-events-none absolute bg-white w-full h-full rounded-md"
            />
            <span
              aria-hidden="true"
              className={classNames(
                phonetic ? "bg-blue-primary" : "bg-gray-200",
                "pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200"
              )}
            />
            <span
              aria-hidden="true"
              className={classNames(
                phonetic ? "translate-x-5" : "translate-x-0",
                "pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200"
              )}
            />
          </Switch>
        </div>
      </div>
      {/* <input type="submit" value="Submit" className="pl-3 pr-3 pt-2 pb-2 rounded-md bg-blue-primary text-white hover:bg-blue-200 "/> */}

      <div className="">
        <button
          value="Submit"
          type="submit"
          className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-primary hover:bg-orange-light hover:text-blue-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
        >
          Submit
        </button>
        <div className="float-right" style={{ display: loading ? "" : "none" }}>
          <Loading
            type={"spinningBubbles"}
            color={"black"}
            style={{ display: "none" }}
          />
        </div>
      </div>
    </form>

    // <div className="pt-2">
    //   <div className="flex justify-between">
    //     <label htmlFor="scdcid" className="block text-sm font-medium text-gray-700">
    //       SCDC ID
    //     </label>
    //     {/* <span className="text-sm text-gray-500" id="email-optional">
    //       Optional
    //     </span> */}
    //   </div>
    //   <div className="mt-1">
    //     <input
    //       type="text"
    //       name="scdcid"
    //       id="scdcid"
    //       className="shadow-sm focus:ring-blue-200 focus:border-blue-200 block w-full mr-20 sm:text-sm border-gray-300 rounded-md"
    //       placeholder="12345678"
    //       aria-describedby="scdcid-optional"
    //     />
    //   </div>
    //   <div className="flex justify-between">
    //     <label htmlFor="sid" className="block text-sm font-medium text-gray-700">
    //       SID
    //     </label>
    //     {/* <span className="text-sm text-gray-500" id="email-optional">
    //       Optional
    //     </span> */}
    //   </div>
    //   <div className="mt-1">
    //     <input
    //       type="text"
    //       name="sid"
    //       id="sid"
    //       className="shadow-sm focus:ring-blue-200 focus:border-blue-200 block w-full mr-20 sm:text-sm border-gray-300 rounded-md"
    //       placeholder="12345678"
    //       aria-describedby="sid-optional"
    //     />
    //   </div>
    //   <div className="flex justify-between">
    //     <label htmlFor="scdcid" className="block text-sm font-medium text-gray-700">
    //       First Name
    //     </label>
    //     {/* <span className="text-sm text-gray-500" id="email-optional">
    //       Optional
    //     </span> */}
    //   </div>
    //   <div className="mt-1">
    //     <input
    //       type="text"
    //       name="scdcid"
    //       id="scdcid"
    //       className="shadow-sm focus:ring-blue-200 focus:border-blue-200 block w-full mr-20 sm:text-sm border-gray-300 rounded-md"
    //       placeholder="12345678"
    //       aria-describedby="scdcid-optional"
    //     />
    //   </div>
    //   <div className="flex justify-between">
    //     <label htmlFor="scdcid" className="block text-sm font-medium text-gray-700">
    //       SCDC ID
    //     </label>
    //     {/* <span className="text-sm text-gray-500" id="email-optional">
    //       Optional
    //     </span> */}
    //   </div>
    //   <div className="mt-1">
    //     <input
    //       type="text"
    //       name="scdcid"
    //       id="scdcid"
    //       className="shadow-sm focus:ring-blue-200 focus:border-blue-200 block w-full mr-20 sm:text-sm border-gray-300 rounded-md"
    //       placeholder="12345678"
    //       aria-describedby="scdcid-optional"
    //     />
    //   </div>
    // </div>
  );
}

export default SearchFormBasic;
